import { render } from "./WithDescription.vue?vue&type=template&id=a721177a"
import script from "./WithDescription.vue?vue&type=script&lang=ts"
export * from "./WithDescription.vue?vue&type=script&lang=ts"
script.render = render

export default script